import { useStaticQuery, graphql } from "gatsby"
import { useColorPreset } from "@app/hooks/useColorPreset"
export const useAnnouncement = () => {
  const { data } = useStaticQuery<GatsbyTypes.StaticAnnouncementsQuery>(graphql`
    query StaticAnnouncements {
      data: sanitySettingAnnouncement {
        announcements {
          ...LinkFragment
        }
        backgroundColor {
          ...NewPresetColorFragment
        }
      }
    }
  `)

  const items = data?.announcements || []
  const defaultBgColour = useColorPreset(data?.backgroundColor)?.color || "preset.greenAccent"

  return {
    items,
    defaultBgColour,
  }
}
